import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class SupportTicketService {
	constructor(private http: HttpClient) {}

	createTicket(formData: FormData) {
		const url = `${environment.api}customer_support/create`;
		return this.http.post(url, formData);
	}

	getAllTickets(start_date: string, end_date: string) {

		const url = `${environment.api}admin/support-tickets/get_all`;
		const formData = new FormData();
		formData.append('start_date', start_date);
		formData.append('end_date', end_date);
		return this.http.post(url, formData);
	}

	getTicketById(ticketId: number) {
		const url = `${environment.api}customer_support/${ticketId}/select_by_id`;
		return this.http.get(url);
	}

	getTicketChats(ticketId: number) {
		const url = `${environment.api}support-tickets/${ticketId}/get_chats`;
		return this.http.get(url);
	}

	answerTicket(ticketId: number, message: string, userId: number) {
		const url = `${environment.api}support-tickets/create_chat`;
		const formData = new FormData();
		formData.append('ticket_id', ticketId.toString());
		formData.append('message', message);
		formData.append('from_user_id', userId.toString());
		return this.http.post(url, formData);
	}

	changeStatus(ticketId: number, status: string) {
		const url = `${environment.api}support-tickets/change_status`;
		const formData = new FormData();
		formData.append('ticket_id', ticketId.toString());
		formData.append('status', status);
		return this.http.post(url, formData);
	}
}
